window.ga4.prepare_game_item = function(game, position, language, currency, listName) {

    const tags = [];
    if(game.productPrice && game.productPrice.originalPriceInMCU) {
        tags.push('S');
    }
    if(game.availableVariants.length > 1) {
        tags.push('V');
    }
    if(game.productInfo.isCreation) {
        tags.push('C');
    }
    if(game.availableVariants.length === 0) {
        tags.push('O');
    }
    const ringSizes = [...new Set(
        game.localisation.variants
            .filter(variant => variant.ringSize !== undefined)
            .map(variant => variant.ringSize)
            .sort()
    )];
    const materials = [...new Set(
        game.availableVariants
            .filter(variant => variant.material !== undefined && variant.material !== 'OT')
            .map(variant => variant.material)
    )];

    const data = {
        itemId: game.productBase.productId,
        affiliation: language,
        currency: currency,
        item_category: game.productInfo.type,
        item_list_name: listName,
        index: position
    };

    if(game.productPrice !== undefined) {
        data.price = (game.productPrice.priceInMCU/100).toFixed(2);
    }
    if(ringSizes.length > 0) {
        data.item_category2 = ringSizes.join(', ');
    }
    if(materials.length > 0) {
        data.item_category3 = materials.join(', ');
    }
    if(tags.length > 0) {
        data.item_category4 = tags.join(', ');
    }
    if(game.productPrice && game.productPrice.originalPriceInMCU) {
        data.item_category5 = (game.productPrice.originalPriceInMCU/100).toFixed(0);
    }

    return data;

};

window.ga4.get_item = function(productId) {
    if(!window.ga4.products[productId]) {
        return null
    }
    return { ...window.ga4.products[productId] }
}

window.ga4.select_item = function(productId, listName, position) {
   
    const itemData = this.get_item(productId)
    itemData.index = position
   
    window.gtag('event','select_item', {
        item_list_name: listName,
        items:[ itemData ]
    })
}

window.ga4.view_item_list = function(productIds, listName, positionOffset) {
    
    const itemsData = productIds
        .map((productId) => this.get_item(productId))
        .filter((itemData) => itemData !== null)
    
    itemsData.forEach((itemData, i) => itemData.position = positionOffset+i)
   
    window.gtag('event','view_item_list', {
        item_list_name: listName,
        items: itemsData
    })
}

// click events

document.querySelectorAll('*[x-ga4-select-item]').forEach((item) => {
    item.addEventListener('click', (e) => {
        const [ productId, position, ...listName] = item.getAttribute('x-alg-search-click').split(':')
        window.ga4.select_item(
            productId,
            listName.join(':'),
            position
        )
    })
})